import { render, staticRenderFns } from "./PlanPricesModal.vue?vue&type=template&id=0bc5c35c"
import script from "./PlanPricesModal.vue?vue&type=script&lang=js"
export * from "./PlanPricesModal.vue?vue&type=script&lang=js"
import style0 from "./PlanPricesModal.vue?vue&type=style&index=0&id=0bc5c35c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports